// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { EntityList, Product } from "../flow/types";
// import type {Action} from "../flow/types";

export default function(
  state: EntityList<Product> = initialState.featuredProducts,
  action: any
) {
  switch (action.type) {
    case ActionTypes.GET_FEATURED_PRODUCTS + ActionTypes.FULFILLED:
      var data = action.payload.data;
      const result: EntityList<Product> = new EntityList(
        data.result,
        data.totalPages
      );
      return result;
    default:
      return state;
  }
}
